import { getContext } from '@fiverr-private/fiverr_context';
import { AllocationGroups } from '../../constants/experiments';

export const useExperiment = (experimentId: number) => {
    const { abTests } = getContext();
    const group = Number(abTests[experimentId]);

    return {
        group: group ? group : undefined,
        unallocated: !(experimentId in abTests),
        inControl: group === AllocationGroups.A,
        inExperiment: group > AllocationGroups.A,
        inGroupB: group === AllocationGroups.B,
        inGroupC: group === AllocationGroups.C,
        inGroupD: group === AllocationGroups.D,
        inGroupE: group === AllocationGroups.E,
    };
};
